import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

class Authenticator {

  public async getLoggedInUser(): Promise<firebase.User | null> {
    await firebase.auth().currentUser
    const user = await firebase.auth().currentUser
    return user
  }

  public async login(email: string, password: string) {
    await firebase.auth().signInWithEmailAndPassword(email, password);
  }

  public async logout() {
    await firebase.auth().signOut();
  }

  public async getToken(): Promise<string | null> {
    await this.waitForLogin()
    const token = await firebase.auth().currentUser?.getIdToken()
    const currentUser = await firebase.auth().currentUser
    console.log({ currentUser, token })
    return token || null 
  }

  private hasLoggedIn = false;
  private async waitForLogin() {
    return new Promise((resolve) => {
      if (this.hasLoggedIn) {
        resolve(true)
      }
      let waitForCurrentUser = setInterval(() => {
        if ( firebase.auth().currentUser?.uid) {
            this.hasLoggedIn = true
            clearInterval(waitForCurrentUser);
            resolve(true)
        }
      }, 50);
    })
  }
  
}

export const authenticator = new Authenticator()